import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, LockIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function ResetPassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/auth/login');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-298">
      <div className="px-4 py-6 flex items-center" data-id="element-299">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-white hover:bg-surface rounded-full transition-colors" data-id="element-300">
          <ArrowLeftIcon size={24} data-id="element-301" />
        </button>
      </div>

      <div className="flex-1 px-6 pb-6" data-id="element-302">
        <div className="mb-8" data-id="element-303">
          <h1 className="text-3xl font-poppins font-bold text-white mb-2" data-id="element-304">
            Create new password
          </h1>
          <p className="text-softGray" data-id="element-305">
            Choose a strong password you'll remember.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5" data-id="element-306">
          <div className="relative" data-id="element-307">
            <Input label="New Password" placeholder="Enter new password" icon={<LockIcon size={20} data-id="element-309" />} type={showPassword ? 'text' : 'password'} data-id="element-308" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-[38px] text-softGray text-sm font-medium" data-id="element-310">
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          <Input label="Confirm Password" placeholder="Confirm new password" icon={<LockIcon size={20} data-id="element-312" />} type={showPassword ? 'text' : 'password'} data-id="element-311" />
          <Button type="submit" className="mt-4" data-id="element-313">
            Save Password
          </Button>
        </form>
      </div>
    </div>;
}